import { Component } from '@angular/core';
import { AuthService } from '@authentication/auth.service';
import { fadeAnimationTrigger } from '@shared/animations';
import { TipoUsuario } from '@shared/enums/tipoUsuario';

@Component({
  selector: 'app-despacho-index',
  templateUrl: './despacho-index.component.html',
  styleUrls: ['./despacho-index.component.scss'],
  animations:[ fadeAnimationTrigger ]
})
export class DespachoIndexComponent {

  TipoUsuario = TipoUsuario;
  
  constructor(private authService: AuthService) { }

  hasRole(...roles: TipoUsuario[]) {
    return this.authService.hasRole(...roles);
  }
}
